import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from "../../constants/AuthConstant";
import operasionalBiayaLainnyaService from "../../services/operasionalBiayaLainnyaService";
import Cookies from "js-cookie";

export const initialState = {
    loading: false,
    data: [],
    showMessage: false,
    message: '',
}

export const getDataOperasionalBiayaLainnya = createAsyncThunk('operasionalBiayaLainnya/data', async (data, { rejectWithValue }) => {
    try {
        const response = await operasionalBiayaLainnyaService.data(Cookies.get(AUTH_TOKEN), data)
        return response
    } catch (err) {
        return rejectWithValue(err.response?.data || 'Error fetching data')
    }
})

export const storeOperasionalBiayaLainnya = createAsyncThunk('operasionalBiayaLainnya/store', async (data, { rejectWithValue }) => {
    try {
        const response = await operasionalBiayaLainnyaService.store(Cookies.get(AUTH_TOKEN), data)
        return response
    } catch (err) {
        return rejectWithValue(err.response?.data || 'Error storing data')
    }
})

export const updateOperasionalBiayaLainnya = createAsyncThunk('operasionalBiayaLainnya/update', async (data, { rejectWithValue }) => {
    try {
        const response = await operasionalBiayaLainnyaService.update(Cookies.get(AUTH_TOKEN), data)
        return response
    } catch (err) {
        return rejectWithValue(err.response?.data || 'Error updating data')
    }
})

export const deleteOperasionalBiayaLainnya = createAsyncThunk('operasionalBiayaLainnya/delete', async (data, { rejectWithValue }) => {
    try {
        const response = await operasionalBiayaLainnyaService.delete(Cookies.get(AUTH_TOKEN), data)
        return response
    } catch (err) {
        return rejectWithValue(err.response?.data || 'Error deleting data')
    }
})

export const operasionalBiayaLainnyaSlice = createSlice({
    name: 'operasionalBiayaLainnya',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataOperasionalBiayaLainnya.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload ?? []
            })
            .addCase(getDataOperasionalBiayaLainnya.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataOperasionalBiayaLainnya.rejected, (state, action) => {
                state.loading = false
                state.data = action.payload
            })
    },
})

export const {
    showLoading,
} = operasionalBiayaLainnyaSlice.actions

export default operasionalBiayaLainnyaSlice.reducer
